import{compose as t,path as r}from"ramda";import{getPath as a}from"../getPath/getPath.js";const o=t(r,a);export{o as getProperty};
